export default __webpack_public_path__ + "static/media/payment-method-apple.b4010f0c.svg";